import Link from 'gatsby-link'
import { kebabCase } from 'lodash'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import React from 'react'
import Content, { HTMLContent } from '../components/Content'
import Layout from '../components/Layout'

export const EventTemplate = ({
  content,
  contentComponent,
  image,
  registration_link,
  tags,
  title,
}) => {
  const EventContent = contentComponent || Content

  return (
    <Layout>
      <section className="section">
        <div className="container content">
          <div className="columns">
            <div className="column is-10 is-offset-1">
              <h1 className="title is-size-2 has-text-weight-bold is-bold-light">
                {title}
              </h1>
              <div
                style={{
                  textAlign: 'center',
                }}
              >
                <img src={image} alt={title} />
                <div className="register-button">
                  <a
                    children="Register Now"
                    className="button is-link is-outlined is-rounded is-medium"
                    href={registration_link}
                  />
                </div>
              </div>
              <EventContent content={content} />
              {tags && tags.length ? (
                <div style={{ marginTop: `4rem`, textAlign: 'center' }}>
                  <h2>Tags</h2>
                  <ul className="tag-list">
                    {tags.map((tag) => (
                      <li key={tag + `tag`}>
                        <Link to={`/tags/${kebabCase(tag)}/`}>{tag}</Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

EventTemplate.propTypes = {
  content: PropTypes.string.isRequired,
  contentComponent: PropTypes.func,
  image: PropTypes.string,
  tags: PropTypes.array,
  event_date: PropTypes.string,
  registration_link: PropTypes.string,
  title: PropTypes.string,
}

const EventPage = ({ data }) => {
  const { markdownRemark: event } = data

  return (
    <EventTemplate
      content={event.html}
      contentComponent={HTMLContent}
      image={event.frontmatter.image}
      event_date={event.frontmatter.event_date}
      registration_link={event.frontmatter.registration_link}
      tags={event.frontmatter.tags}
      title={event.frontmatter.title}
    />
  )
}

EventPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object,
  }),
}

export default EventPage

export const eventQuery = graphql`
  query EventByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        image {
          childImageSharp {
            gatsbyImageData(width: 120, quality: 100, layout: CONSTRAINED)
          }
        }
        event_date(formatString: "MMMM DD, YYYY")
        registration_link
        tags
        title
      }
    }
  }
`
